import type { RootState } from "@/app/store";
import { Servidor } from "@/contexts/cadastro/servidor/model/Servidor";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ServidorState {
  items: Servidor[];
  synced: boolean;
}

const initialState: ServidorState = {
  items: [],
  synced: false,
};

const servidorSlice = createSlice({
  name: "SERVIDOR",
  initialState,
  reducers: {
    sync: {
      reducer: (state, action: PayloadAction<{ items: Servidor[] }>) => {
        state.items = action.payload.items;
        state.synced = true;
      },
      prepare: (items: Servidor[]) => ({
        payload: { items },
      }),
    },
  },
});

export const servidorAction = servidorSlice.actions;

export default servidorSlice.reducer;

export const getServidoresSynced = (state: RootState) => state.servidor.items;
